// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    /* ------------------------------------------------------------- */
    /* Light Mode: Folk & Linear-inspired clean neutral zinc palette with #F7F7F7 surface */
    /* ------------------------------------------------------------- */
    --canvas: 0 0% 96.9%; /* #F7F7F7 */
    --background: 0 0% 96.9%; /* #F7F7F7 */
    --foreground: 240 10% 3.9%;

    --card: 0 0% 100%;
    --card-foreground: 240 10% 3.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 240 10% 3.9%;

    /* Solid charcoal / deep black primary CTA */
    --primary: 240 5.9% 10%;
    --primary-foreground: 0 0% 98%;
    --secondary: 240 4.8% 95.9%;
    --secondary-foreground: 240 5.9% 10%;
    --muted: 240 4.8% 95.9%;
    --muted-foreground: 240 3.8% 46.1%;
    --accent: 240 4.8% 95.9%;
    --accent-foreground: 240 5.9% 10%;

    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 0 0% 98%;
    --border: 240 5.9% 90%;
    --input: 240 5.9% 90%;
    --ring: 240 5.9% 10%;
    --radius: 0.75rem;

    --brand: 240 5.9% 10%;
    --brand-foreground: 0 0% 98%;
    --brand-soft: 240 4.8% 95.9%;
    --color-brand-primary: #18181b;
    --color-brand-foreground: #ffffff;

    --success: 142 72% 29%;
    --success-soft: 142 50% 94%;
    --success-solid: 142 70% 40%;
    --warning: 38 92% 38%;
    --warning-soft: 40 90% 94%;
    --warning-solid: 38 92% 50%;
    --danger: 0 72% 45%;
    --danger-soft: 0 70% 95%;
    --danger-solid: 0 72% 50%;
    --info: 240 5.9% 10%;
    --info-soft: 240 4.8% 95.9%;
    --info-solid: 240 5.9% 10%;
    --violet: 267 50% 45%;
    --violet-soft: 262 70% 94%;

    --tile: 240 5.9% 10%;
    --tile-foreground: 0 0% 100%;
    --ai-glow: 54 90% 70%;
    --ai-tile: 52 90% 88%;

    --chart-1: 240 5.9% 10%;
    --chart-2: 142 70% 45%;
    --chart-3: 38 92% 50%;
    --chart-4: 267 50% 55%;
    --chart-5: 0 72% 50%;

    --shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.04), 0 1px 2px -1px rgb(0 0 0 / 0.04);
    --shadow-pop: 0 10px 25px -5px rgb(0 0 0 / 0.06), 0 8px 10px -6px rgb(0 0 0 / 0.04);
    --shadow-shell: 0 20px 40px -15px rgb(0 0 0 / 0.08);
  }

  .dark {
    /* ------------------------------------------------------------- */
    /* Dark Mode: True OLED pitch black + crisp dark zinc depth     */
    /* ------------------------------------------------------------- */
    --canvas: 0 0% 0%;
    --background: 0 0% 0%;
    --foreground: 0 0% 98%;

    --card: 240 10% 3.9%;
    --card-foreground: 0 0% 98%;
    --popover: 240 10% 3.9%;
    --popover-foreground: 0 0% 98%;

    /* Crisp white CTA button in dark mode */
    --primary: 0 0% 98%;
    --primary-foreground: 240 5.9% 10%;
    --secondary: 240 3.7% 15.9%;
    --secondary-foreground: 0 0% 98%;
    --muted: 240 3.7% 15.9%;
    --muted-foreground: 240 5% 64.9%;
    --accent: 240 3.7% 15.9%;
    --accent-foreground: 0 0% 98%;

    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 0% 98%;
    --border: 240 3.7% 15.9%;
    --input: 240 3.7% 15.9%;
    --ring: 0 0% 98%;

    --brand: 0 0% 98%;
    --brand-foreground: 0 0% 100%;
    --brand-soft: 240 3.7% 15.9%;
    --color-brand-primary: #f4f4f5;
    --color-brand-foreground: #09090b;

    --success: 142 70% 50%;
    --success-soft: 142 50% 12%;
    --success-solid: 142 70% 45%;
    --warning: 38 90% 60%;
    --warning-soft: 38 45% 14%;
    --warning-solid: 38 85% 52%;
    --danger: 0 84% 65%;
    --danger-soft: 0 45% 15%;
    --danger-solid: 0 84% 58%;
    --info: 0 0% 98%;
    --info-soft: 240 3.7% 15.9%;
    --info-solid: 0 0% 98%;
    --violet: 265 80% 70%;
    --violet-soft: 265 40% 16%;

    --tile: 0 0% 12%;
    --tile-foreground: 0 0% 96%;
    --ai-glow: 54 80% 45%;
    --ai-tile: 50 35% 15%;

    --chart-1: 0 0% 98%;
    --chart-2: 142 70% 50%;
    --chart-3: 38 90% 60%;
    --chart-4: 267 70% 72%;
    --chart-5: 0 84% 65%;

    /* OLED deep black depth: crisp 1px borders + high-contrast shadows */
    --shadow-card: 0 0 0 1px hsl(0 0% 100% / .08), 0 2px 10px hsl(0 0% 0% / .8);
    --shadow-pop: 0 0 0 1px hsl(0 0% 100% / .10), 0 16px 40px -12px hsl(0 0% 0% / .95);
    --shadow-shell: 0 24px 60px -24px hsl(0 0% 0% / .98);
  }

  *{
  --tw-border-opacity: 1;
  border-color: hsl(var(--border) / var(--tw-border-opacity, 1));
}

  html {
    -webkit-text-size-adjust: 100%;
    scroll-behavior: smooth;
  }

  body{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--background) / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
    font-feature-settings: "cv11", "ss01";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
}

  /* Universal high-performance interactive states */
  button,
  a,
  input,
  select,
  textarea {
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  /* Sleek modern scrollbars across all desktop browsers */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: hsl(var(--muted-foreground) / 0.25);
    border-radius: 9999px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: hsl(var(--muted-foreground) / 0.45);
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: hsl(var(--muted-foreground) / 0.25) transparent;
  }

  /* Clean tabular and numeric alignments */
  .tabular,
  table,
  [data-numeric] {
    font-variant-numeric: tabular-nums;
  }

  /* Strict anti-blue/anti-yellow browser autofill overrides */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px hsl(var(--card)) inset !important;
    -webkit-text-fill-color: hsl(var(--foreground)) !important;
    caret-color: hsl(var(--foreground)) !important;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
  }
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}
@media (min-width: 1440px){

  .container{
    max-width: 1440px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-x-3{
  left: 0.75rem;
  right: 0.75rem;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.inset-y-2{
  top: 0.5rem;
  bottom: 0.5rem;
}
.-left-\\[21px\\]{
  left: -21px;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-3{
  bottom: 0.75rem;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-3{
  top: 0.75rem;
}
.top-3\\.5{
  top: 0.875rem;
}
.top-4{
  top: 1rem;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-modal{
  z-index: 60;
}
.z-sticky{
  z-index: 10;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.m-0{
  margin: 0px;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[112px\\]{
  height: 112px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[196px\\]{
  height: 196px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[420px\\]{
  height: 420px;
}
.h-\\[52px\\]{
  height: 52px;
}
.h-\\[76px\\]{
  height: 76px;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[90dvh\\]{
  max-height: 90dvh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92dvh\\]{
  max-height: 92dvh;
}
.max-h-\\[min\\(320px\\2c 45dvh\\)\\]{
  max-height: min(320px, 45dvh);
}
.max-h-\\[min\\(640px\\2c 72dvh\\)\\]{
  max-height: min(640px, 72dvh);
}
.max-h-\\[min\\(680px\\2c 75dvh\\)\\]{
  max-height: min(680px, 75dvh);
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[112px\\]{
  min-height: 112px;
}
.min-h-\\[148px\\]{
  min-height: 148px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[34px\\]{
  min-height: 34px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[440px\\]{
  min-height: 440px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[68px\\]{
  min-height: 68px;
}
.min-h-\\[72px\\]{
  min-height: 72px;
}
.min-h-dvh{
  min-height: 100dvh;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[340px\\]{
  width: 340px;
}
.w-\\[480px\\]{
  width: 480px;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[110px\\]{
  min-width: 110px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[130px\\]{
  min-width: 130px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-\\[85px\\]{
  min-width: 85px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[130px\\]{
  max-width: 130px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[170px\\]{
  max-width: 170px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[340px\\]{
  max-width: 340px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.border-separate{
  border-collapse: separate;
}
.border-spacing-0{
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-\\[bounce_1s_infinite_100ms\\]{
  animation: bounce 1s infinite 100ms;
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-\\[bounce_1s_infinite_200ms\\]{
  animation: bounce 1s infinite 200ms;
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-\\[bounce_1s_infinite_300ms\\]{
  animation: bounce 1s infinite 300ms;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-\\[spin_3s_linear_infinite_reverse\\]{
  animation: spin 3s linear infinite reverse;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-manipulation{
  touch-action: manipulation;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize{
  resize: both;
}
.list-disc{
  list-style-type: disc;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: hsl(var(--border) / var(--tw-divide-opacity, 1));
}
.divide-border\\/50 > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border) / 0.5);
}
.divide-border\\/60 > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border) / 0.6);
}
.divide-zinc-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-divide-opacity, 1));
}
.justify-self-end{
  justify-self: end;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[2px\\]{
  border-radius: 2px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-card{
  border-radius: 16px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-\\[2\\.5px\\]{
  border-width: 2.5px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-dashed{
  border-style: dashed;
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/20{
  border-color: rgb(245 158 11 / 0.2);
}
.border-amber-500\\/25{
  border-color: rgb(245 158 11 / 0.25);
}
.border-amber-500\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-blue-500\\/20{
  border-color: rgb(59 130 246 / 0.2);
}
.border-border{
  --tw-border-opacity: 1;
  border-color: hsl(var(--border) / var(--tw-border-opacity, 1));
}
.border-border\\/40{
  border-color: hsl(var(--border) / 0.4);
}
.border-border\\/50{
  border-color: hsl(var(--border) / 0.5);
}
.border-border\\/60{
  border-color: hsl(var(--border) / 0.6);
}
.border-border\\/70{
  border-color: hsl(var(--border) / 0.7);
}
.border-border\\/80{
  border-color: hsl(var(--border) / 0.8);
}
.border-danger\\/20{
  border-color: hsl(var(--danger) / 0.2);
}
.border-destructive\\/20{
  border-color: hsl(var(--destructive) / 0.2);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20{
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-500\\/25{
  border-color: rgb(16 185 129 / 0.25);
}
.border-foreground{
  --tw-border-opacity: 1;
  border-color: hsl(var(--foreground) / var(--tw-border-opacity, 1));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/20{
  border-color: rgb(99 102 241 / 0.2);
}
.border-input{
  --tw-border-opacity: 1;
  border-color: hsl(var(--input) / var(--tw-border-opacity, 1));
}
.border-orange-500\\/25{
  border-color: rgb(249 115 22 / 0.25);
}
.border-pink-500\\/20{
  border-color: rgb(236 72 153 / 0.2);
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: hsl(var(--primary) / var(--tw-border-opacity, 1));
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-purple-500\\/20{
  border-color: rgb(168 85 247 / 0.2);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20{
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/25{
  border-color: rgb(239 68 68 / 0.25);
}
.border-red-500\\/30{
  border-color: rgb(239 68 68 / 0.3);
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-500\\/25{
  border-color: rgb(14 165 233 / 0.25);
}
.border-success\\/20{
  border-color: hsl(var(--success) / 0.2);
}
.border-success\\/30{
  border-color: hsl(var(--success) / 0.3);
}
.border-transparent{
  border-color: transparent;
}
.border-warning\\/20{
  border-color: hsl(var(--warning) / 0.2);
}
.border-warning\\/30{
  border-color: hsl(var(--warning) / 0.3);
}
.border-zinc-100{
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity, 1));
}
.border-zinc-200{
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.border-zinc-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.border-zinc-400{
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity, 1));
}
.border-zinc-900{
  --tw-border-opacity: 1;
  border-color: rgb(24 24 27 / var(--tw-border-opacity, 1));
}
.border-zinc-950{
  --tw-border-opacity: 1;
  border-color: rgb(9 9 11 / var(--tw-border-opacity, 1));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/15{
  background-color: rgb(245 158 11 / 0.15);
}
.bg-amber-500\\/5{
  background-color: rgb(245 158 11 / 0.05);
}
.bg-background{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--background) / var(--tw-bg-opacity, 1));
}
.bg-background\\/50{
  background-color: hsl(var(--background) / 0.5);
}
.bg-background\\/60{
  background-color: hsl(var(--background) / 0.6);
}
.bg-background\\/80{
  background-color: hsl(var(--background) / 0.8);
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/60{
  background-color: rgb(239 246 255 / 0.6);
}
.bg-blue-500\\/10{
  background-color: rgb(59 130 246 / 0.1);
}
.bg-border{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--border) / var(--tw-bg-opacity, 1));
}
.bg-border\\/60{
  background-color: hsl(var(--border) / 0.6);
}
.bg-card{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--card) / var(--tw-bg-opacity, 1));
}
.bg-card\\/40{
  background-color: hsl(var(--card) / 0.4);
}
.bg-card\\/50{
  background-color: hsl(var(--card) / 0.5);
}
.bg-card\\/60{
  background-color: hsl(var(--card) / 0.6);
}
.bg-card\\/90{
  background-color: hsl(var(--card) / 0.9);
}
.bg-card\\/95{
  background-color: hsl(var(--card) / 0.95);
}
.bg-danger-soft{
  background-color: hsl(var(--danger-soft));
}
.bg-danger-solid{
  background-color: hsl(var(--danger-solid));
}
.bg-destructive{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--destructive) / var(--tw-bg-opacity, 1));
}
.bg-destructive\\/10{
  background-color: hsl(var(--destructive) / 0.1);
}
.bg-destructive\\/5{
  background-color: hsl(var(--destructive) / 0.05);
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/5{
  background-color: rgb(16 185 129 / 0.05);
}
.bg-foreground{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--foreground) / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/10{
  background-color: rgb(99 102 241 / 0.1);
}
.bg-info-soft{
  background-color: hsl(var(--info-soft));
}
.bg-muted{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1));
}
.bg-muted-foreground{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted-foreground) / var(--tw-bg-opacity, 1));
}
.bg-muted-foreground\\/30{
  background-color: hsl(var(--muted-foreground) / 0.3);
}
.bg-muted-foreground\\/40{
  background-color: hsl(var(--muted-foreground) / 0.4);
}
.bg-muted\\/15{
  background-color: hsl(var(--muted) / 0.15);
}
.bg-muted\\/20{
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/30{
  background-color: hsl(var(--muted) / 0.3);
}
.bg-muted\\/40{
  background-color: hsl(var(--muted) / 0.4);
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-muted\\/60{
  background-color: hsl(var(--muted) / 0.6);
}
.bg-muted\\/70{
  background-color: hsl(var(--muted) / 0.7);
}
.bg-pink-500\\/10{
  background-color: rgb(236 72 153 / 0.1);
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/5{
  background-color: hsl(var(--primary) / 0.05);
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10{
  background-color: rgb(168 85 247 / 0.1);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/5{
  background-color: rgb(239 68 68 / 0.05);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--secondary) / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-sky-500\\/10{
  background-color: rgb(14 165 233 / 0.1);
}
.bg-success{
  background-color: hsl(var(--success));
}
.bg-success-soft{
  background-color: hsl(var(--success-soft));
}
.bg-tile{
  background-color: hsl(var(--tile));
}
.bg-violet-500\\/10{
  background-color: rgb(139 92 246 / 0.1);
}
.bg-violet-soft{
  background-color: hsl(var(--violet-soft));
}
.bg-warning{
  background-color: hsl(var(--warning));
}
.bg-warning-soft{
  background-color: hsl(var(--warning-soft));
}
.bg-warning-solid{
  background-color: hsl(var(--warning-solid));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-zinc-100{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-zinc-200{
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}
.bg-zinc-300{
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity, 1));
}
.bg-zinc-400{
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity, 1));
}
.bg-zinc-50\\/50{
  background-color: rgb(250 250 250 / 0.5);
}
.bg-zinc-500\\/10{
  background-color: rgb(113 113 122 / 0.1);
}
.bg-zinc-900{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}
.bg-zinc-950{
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}
.bg-zinc-950\\/\\[0\\.04\\]{
  background-color: rgb(9 9 11 / 0.04);
}
.fill-current{
  fill: currentColor;
}
.fill-foreground{
  fill: hsl(var(--foreground) / 1);
}
.stroke-amber-500{
  stroke: #f59e0b;
}
.stroke-current{
  stroke: currentColor;
}
.stroke-emerald-500{
  stroke: #10b981;
}
.stroke-muted{
  stroke: hsl(var(--muted) / 1);
}
.stroke-red-500{
  stroke: #ef4444;
}
.stroke-\\[2\\.2\\]{
  stroke-width: 2.2;
}
.stroke-\\[2\\.5\\]{
  stroke-width: 2.5;
}
.stroke-\\[2\\]{
  stroke-width: 2;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-\\[calc\\(56px\\+env\\(safe-area-inset-bottom\\2c 0px\\)\\+1\\.5rem\\)\\]{
  padding-bottom: calc(56px + env(safe-area-inset-bottom,0px) + 1.5rem);
}
.pb-\\[max\\(env\\(safe-area-inset-bottom\\)\\2c 1\\.25rem\\)\\]{
  padding-bottom: max(env(safe-area-inset-bottom), 1.25rem);
}
.pb-\\[max\\(env\\(safe-area-inset-bottom\\)\\2c 1\\.5rem\\)\\]{
  padding-bottom: max(env(safe-area-inset-bottom), 1.5rem);
}
.pb-\\[max\\(env\\(safe-area-inset-bottom\\)\\2c 1rem\\)\\]{
  padding-bottom: max(env(safe-area-inset-bottom), 1rem);
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-3\\.5{
  padding-top: 0.875rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
.font-sans{
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-\\[18px\\]{
  line-height: 18px;
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.25em\\]{
  letter-spacing: 0.25em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--card-foreground) / var(--tw-text-opacity, 1));
}
.text-danger{
  color: hsl(var(--danger));
}
.text-danger\\/80{
  color: hsl(var(--danger) / 0.8);
}
.text-destructive{
  --tw-text-opacity: 1;
  color: hsl(var(--destructive) / var(--tw-text-opacity, 1));
}
.text-destructive-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--destructive-foreground) / var(--tw-text-opacity, 1));
}
.text-destructive\\/80{
  color: hsl(var(--destructive) / 0.8);
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-950{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}
.text-foreground\\/70{
  color: hsl(var(--foreground) / 0.7);
}
.text-foreground\\/80{
  color: hsl(var(--foreground) / 0.8);
}
.text-foreground\\/90{
  color: hsl(var(--foreground) / 0.9);
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-info{
  color: hsl(var(--info));
}
.text-inherit{
  color: inherit;
}
.text-muted-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.text-muted-foreground\\/40{
  color: hsl(var(--muted-foreground) / 0.4);
}
.text-muted-foreground\\/70{
  color: hsl(var(--muted-foreground) / 0.7);
}
.text-muted-foreground\\/80{
  color: hsl(var(--muted-foreground) / 0.8);
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-primary{
  --tw-text-opacity: 1;
  color: hsl(var(--primary) / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-600\\/70{
  color: rgb(220 38 38 / 0.7);
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--secondary-foreground) / var(--tw-text-opacity, 1));
}
.text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-success{
  color: hsl(var(--success));
}
.text-tile-foreground{
  color: hsl(var(--tile-foreground));
}
.text-violet{
  color: hsl(var(--violet));
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-warning{
  color: hsl(var(--warning));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-zinc-300{
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}
.text-zinc-400{
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-zinc-600{
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.text-zinc-700{
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
}
.text-zinc-900{
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow: var(--shadow-card);
  --tw-shadow-colored: var(--shadow-card);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-pop{
  --tw-shadow: var(--shadow-pop);
  --tw-shadow-colored: var(--shadow-pop);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/\\[0\\.04\\]{
  --tw-shadow-color: rgb(0 0 0 / 0.04);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-card{
  --tw-shadow-color: hsl(var(--card) / 1);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-background{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--background) / var(--tw-ring-opacity, 1));
}
.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-black\\/\\[0\\.03\\]{
  --tw-ring-color: rgb(0 0 0 / 0.03);
}
.ring-border{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--border) / var(--tw-ring-opacity, 1));
}
.ring-border\\/20{
  --tw-ring-color: hsl(var(--border) / 0.2);
}
.ring-border\\/50{
  --tw-ring-color: hsl(var(--border) / 0.5);
}
.ring-border\\/70{
  --tw-ring-color: hsl(var(--border) / 0.7);
}
.ring-border\\/80{
  --tw-ring-color: hsl(var(--border) / 0.8);
}
.ring-card{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--card) / var(--tw-ring-opacity, 1));
}
.ring-primary\\/30{
  --tw-ring-color: hsl(var(--primary) / 0.3);
}
.ring-purple-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.ring-zinc-800\\/20{
  --tw-ring-color: rgb(39 39 42 / 0.2);
}
.ring-zinc-900{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(24 24 27 / var(--tw-ring-opacity, 1));
}
.ring-zinc-950{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(9 9 11 / var(--tw-ring-opacity, 1));
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background) / 1);
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[stroke-dasharray\\]{
  transition-property: stroke-dasharray;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in{
  --tw-enter-opacity: 0;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.fade-in-50{
  --tw-enter-opacity: 0.5;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-full{
  --tw-enter-translate-y: 100%;
}
.duration-150{
  animation-duration: 150ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.paused{
  animation-play-state: paused;
}
.\\@container{
  container-type: inline-size;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

.selection\\:bg-zinc-200 *::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}

.selection\\:text-foreground *::selection{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}

.selection\\:bg-zinc-200::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}

.selection\\:text-foreground::selection{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.placeholder\\:text-muted-foreground::placeholder{
  --tw-text-opacity: 1;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1));
}

.placeholder\\:text-muted-foreground\\/50::placeholder{
  color: hsl(var(--muted-foreground) / 0.5);
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}

.hover\\:border-foreground\\/30:hover{
  border-color: hsl(var(--foreground) / 0.3);
}

.hover\\:border-zinc-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / var(--tw-border-opacity, 1));
}

.hover\\:bg-accent:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-background:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--background) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-card\\/40:hover{
  background-color: hsl(var(--card) / 0.4);
}

.hover\\:bg-danger-soft:hover{
  background-color: hsl(var(--danger-soft));
}

.hover\\:bg-destructive\\/10:hover{
  background-color: hsl(var(--destructive) / 0.1);
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted\\/20:hover{
  background-color: hsl(var(--muted) / 0.2);
}

.hover\\:bg-muted\\/30:hover{
  background-color: hsl(var(--muted) / 0.3);
}

.hover\\:bg-muted\\/40:hover{
  background-color: hsl(var(--muted) / 0.4);
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-muted\\/60:hover{
  background-color: hsl(var(--muted) / 0.6);
}

.hover\\:bg-muted\\/70:hover{
  background-color: hsl(var(--muted) / 0.7);
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500\\/10:hover{
  background-color: rgb(239 68 68 / 0.1);
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-zinc-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-zinc-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-zinc-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-zinc-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}

.hover\\:text-accent-foreground:hover{
  --tw-text-opacity: 1;
  color: hsl(var(--accent-foreground) / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-600:hover{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger:hover{
  color: hsl(var(--danger));
}

.hover\\:text-destructive:hover{
  --tw-text-opacity: 1;
  color: hsl(var(--destructive) / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-600:hover{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-foreground:hover{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:bg-muted\\/70:focus{
  background-color: hsl(var(--muted) / 0.7);
}

.focus\\:text-foreground:focus{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-ring:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--ring) / var(--tw-ring-opacity, 1));
}

.focus\\:ring-zinc-950:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(9 9 11 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-1:focus{
  --tw-ring-offset-width: 1px;
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:border-ring:focus-visible{
  --tw-border-opacity: 1;
  border-color: hsl(var(--ring) / var(--tw-border-opacity, 1));
}

.focus-visible\\:bg-muted\\/30:focus-visible{
  background-color: hsl(var(--muted) / 0.3);
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-blue-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-red-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--ring) / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.99\\]:active{
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:bg-muted:active{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1));
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.group:hover .group-hover\\:bg-muted\\/40{
  background-color: hsl(var(--muted) / 0.4);
}

.group:hover .group-hover\\:bg-muted\\/80{
  background-color: hsl(var(--muted) / 0.8);
}

.group:hover .group-hover\\:text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.peer:checked ~ .peer-checked\\:border-zinc-950{
  --tw-border-opacity: 1;
  border-color: rgb(9 9 11 / var(--tw-border-opacity, 1));
}

.peer:checked ~ .peer-checked\\:bg-zinc-950{
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}

.peer:checked ~ .peer-checked\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.peer:focus-visible ~ .peer-focus-visible\\:outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.peer:focus-visible ~ .peer-focus-visible\\:ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.peer:focus-visible ~ .peer-focus-visible\\:ring-offset-2{
  --tw-ring-offset-width: 2px;
}

.peer:focus-visible ~ .peer-focus-visible\\:ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background) / 1);
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-50{
  opacity: 0.5;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1));
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}

@container (min-width: 640px){

  .\\@\\[640px\\]\\:block{
    display: block;
  }

  .\\@\\[640px\\]\\:hidden{
    display: none;
  }
}

@container (min-width: 768px){

  .\\@\\[768px\\]\\:block{
    display: block;
  }

  .\\@\\[768px\\]\\:table-cell{
    display: table-cell;
  }
}

@media (pointer: coarse){

  .touch\\:h-11{
    height: 2.75rem;
  }

  .touch\\:min-h-\\[40px\\]{
    min-height: 40px;
  }

  .touch\\:min-h-\\[44px\\]{
    min-height: 44px;
  }

  .touch\\:min-h-\\[48px\\]{
    min-height: 48px;
  }

  .touch\\:min-w-\\[44px\\]{
    min-width: 44px;
  }
}

.dark\\:divide-zinc-800:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-divide-opacity, 1));
}

.dark\\:divide-zinc-800\\/60:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(39 39 42 / 0.6);
}

.dark\\:border-amber-800\\/50:is(.dark *){
  border-color: rgb(146 64 14 / 0.5);
}

.dark\\:border-amber-800\\/60:is(.dark *){
  border-color: rgb(146 64 14 / 0.6);
}

.dark\\:border-emerald-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}

.dark\\:border-emerald-800\\/50:is(.dark *){
  border-color: rgb(6 95 70 / 0.5);
}

.dark\\:border-emerald-800\\/60:is(.dark *){
  border-color: rgb(6 95 70 / 0.6);
}

.dark\\:border-indigo-800\\/50:is(.dark *){
  border-color: rgb(55 48 163 / 0.5);
}

.dark\\:border-purple-800\\/60:is(.dark *){
  border-color: rgb(107 33 168 / 0.6);
}

.dark\\:border-red-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-800\\/60:is(.dark *){
  border-color: rgb(153 27 27 / 0.6);
}

.dark\\:border-red-900\\/60:is(.dark *){
  border-color: rgb(127 29 29 / 0.6);
}

.dark\\:border-rose-800\\/60:is(.dark *){
  border-color: rgb(159 18 57 / 0.6);
}

.dark\\:border-sky-800\\/60:is(.dark *){
  border-color: rgb(7 89 133 / 0.6);
}

.dark\\:border-white:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.dark\\:border-white\\/\\[0\\.08\\]:is(.dark *){
  border-color: rgb(255 255 255 / 0.08);
}

.dark\\:border-zinc-100:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity, 1));
}

.dark\\:border-zinc-200:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}

.dark\\:border-zinc-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}

.dark\\:border-zinc-700\\/70:is(.dark *){
  border-color: rgb(63 63 70 / 0.7);
}

.dark\\:border-zinc-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}

.dark\\:border-zinc-800\\/60:is(.dark *){
  border-color: rgb(39 39 42 / 0.6);
}

.dark\\:border-zinc-800\\/70:is(.dark *){
  border-color: rgb(39 39 42 / 0.7);
}

.dark\\:border-zinc-800\\/80:is(.dark *){
  border-color: rgb(39 39 42 / 0.8);
}

.dark\\:border-zinc-800\\/90:is(.dark *){
  border-color: rgb(39 39 42 / 0.9);
}

.dark\\:bg-amber-500\\/20:is(.dark *){
  background-color: rgb(245 158 11 / 0.2);
}

.dark\\:bg-amber-950\\/20:is(.dark *){
  background-color: rgb(69 26 3 / 0.2);
}

.dark\\:bg-amber-950\\/40:is(.dark *){
  background-color: rgb(69 26 3 / 0.4);
}

.dark\\:bg-amber-950\\/50:is(.dark *){
  background-color: rgb(69 26 3 / 0.5);
}

.dark\\:bg-amber-950\\/60:is(.dark *){
  background-color: rgb(69 26 3 / 0.6);
}

.dark\\:bg-black\\/20:is(.dark *){
  background-color: rgb(0 0 0 / 0.2);
}

.dark\\:bg-black\\/95:is(.dark *){
  background-color: rgb(0 0 0 / 0.95);
}

.dark\\:bg-blue-900\\/50:is(.dark *){
  background-color: rgb(30 58 138 / 0.5);
}

.dark\\:bg-blue-950\\/30:is(.dark *){
  background-color: rgb(23 37 84 / 0.3);
}

.dark\\:bg-emerald-500\\/20:is(.dark *){
  background-color: rgb(16 185 129 / 0.2);
}

.dark\\:bg-emerald-950\\/40:is(.dark *){
  background-color: rgb(2 44 34 / 0.4);
}

.dark\\:bg-emerald-950\\/50:is(.dark *){
  background-color: rgb(2 44 34 / 0.5);
}

.dark\\:bg-emerald-950\\/80:is(.dark *){
  background-color: rgb(2 44 34 / 0.8);
}

.dark\\:bg-indigo-950\\/50:is(.dark *){
  background-color: rgb(30 27 75 / 0.5);
}

.dark\\:bg-orange-500\\/20:is(.dark *){
  background-color: rgb(249 115 22 / 0.2);
}

.dark\\:bg-purple-950\\/60:is(.dark *){
  background-color: rgb(59 7 100 / 0.6);
}

.dark\\:bg-red-500\\/20:is(.dark *){
  background-color: rgb(239 68 68 / 0.2);
}

.dark\\:bg-red-950\\/40:is(.dark *){
  background-color: rgb(69 10 10 / 0.4);
}

.dark\\:bg-red-950\\/50:is(.dark *){
  background-color: rgb(69 10 10 / 0.5);
}

.dark\\:bg-rose-950\\/40:is(.dark *){
  background-color: rgb(76 5 25 / 0.4);
}

.dark\\:bg-sky-500\\/20:is(.dark *){
  background-color: rgb(14 165 233 / 0.2);
}

.dark\\:bg-sky-950\\/40:is(.dark *){
  background-color: rgb(8 47 73 / 0.4);
}

.dark\\:bg-white\\/\\[0\\.06\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.06);
}

.dark\\:bg-zinc-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-zinc-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-zinc-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-zinc-800\\/80:is(.dark *){
  background-color: rgb(39 39 42 / 0.8);
}

.dark\\:bg-zinc-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-zinc-900\\/30:is(.dark *){
  background-color: rgb(24 24 27 / 0.3);
}

.dark\\:bg-zinc-900\\/40:is(.dark *){
  background-color: rgb(24 24 27 / 0.4);
}

.dark\\:bg-zinc-900\\/50:is(.dark *){
  background-color: rgb(24 24 27 / 0.5);
}

.dark\\:bg-zinc-900\\/60:is(.dark *){
  background-color: rgb(24 24 27 / 0.6);
}

.dark\\:bg-zinc-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-zinc-950\\/60:is(.dark *){
  background-color: rgb(9 9 11 / 0.6);
}

.dark\\:bg-zinc-950\\/80:is(.dark *){
  background-color: rgb(9 9 11 / 0.8);
}

.dark\\:bg-zinc-950\\/90:is(.dark *){
  background-color: rgb(9 9 11 / 0.9);
}

.dark\\:bg-zinc-950\\/95:is(.dark *){
  background-color: rgb(9 9 11 / 0.95);
}

.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:text-sky-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-700:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}

.dark\\:text-zinc-950:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity, 1));
}

.dark\\:shadow-2xl:is(.dark *){
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-black\\/70:is(.dark *){
  --tw-shadow-color: rgb(0 0 0 / 0.7);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:ring-white:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-white\\/10:is(.dark *){
  --tw-ring-color: rgb(255 255 255 / 0.1);
}

.dark\\:ring-white\\/\\[0\\.05\\]:is(.dark *){
  --tw-ring-color: rgb(255 255 255 / 0.05);
}

.dark\\:ring-zinc-100:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 244 245 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-zinc-200\\/20:is(.dark *){
  --tw-ring-color: rgb(228 228 231 / 0.2);
}

.dark\\:ring-zinc-950:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(9 9 11 / var(--tw-ring-opacity, 1));
}

.dark\\:selection\\:bg-zinc-800 *:is(.dark *)::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

.dark\\:selection\\:bg-zinc-800:is(.dark *)::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:border-zinc-400:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:bg-emerald-950\\/40:hover:is(.dark *){
  background-color: rgb(2 44 34 / 0.4);
}

.dark\\:hover\\:bg-red-500\\/20:hover:is(.dark *){
  background-color: rgb(239 68 68 / 0.2);
}

.dark\\:hover\\:bg-red-950\\/30:hover:is(.dark *){
  background-color: rgb(69 10 10 / 0.3);
}

.dark\\:hover\\:bg-white:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-zinc-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-zinc-800\\/40:hover:is(.dark *){
  background-color: rgb(39 39 42 / 0.4);
}

.dark\\:hover\\:bg-zinc-800\\/80:hover:is(.dark *){
  background-color: rgb(39 39 42 / 0.8);
}

.dark\\:hover\\:bg-zinc-900:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-zinc-900\\/40:hover:is(.dark *){
  background-color: rgb(24 24 27 / 0.4);
}

.dark\\:hover\\:bg-zinc-900\\/60:hover:is(.dark *){
  background-color: rgb(24 24 27 / 0.6);
}

.dark\\:hover\\:text-amber-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:bg-zinc-900:focus:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}

.dark\\:focus\\:ring-white:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-zinc-200:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(228 228 231 / var(--tw-ring-opacity, 1));
}

.peer:checked ~ .dark\\:peer-checked\\:border-zinc-100:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity, 1));
}

.peer:checked ~ .dark\\:peer-checked\\:bg-zinc-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}

.peer:checked ~ .dark\\:peer-checked\\:text-zinc-950:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity, 1));
}

@media (min-width: 440px){

  .min-\\[440px\\]\\:inline{
    display: inline;
  }
}

@media (min-width: 640px){

  .sm\\:inset-x-auto{
    left: auto;
    right: auto;
  }

  .sm\\:inset-y-0{
    top: 0px;
    bottom: 0px;
  }

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-0{
    top: 0px;
  }

  .sm\\:top-4{
    top: 1rem;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .sm\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .sm\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .sm\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-12{
    margin-bottom: 3rem;
  }

  .sm\\:ml-3{
    margin-left: 0.75rem;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline-block{
    display: inline-block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:h-5{
    height: 1.25rem;
  }

  .sm\\:h-8{
    height: 2rem;
  }

  .sm\\:h-9{
    height: 2.25rem;
  }

  .sm\\:h-\\[calc\\(100dvh-1\\.5rem\\)\\]{
    height: calc(100dvh - 1.5rem);
  }

  .sm\\:h-full{
    height: 100%;
  }

  .sm\\:max-h-\\[85vh\\]{
    max-height: 85vh;
  }

  .sm\\:max-h-none{
    max-height: none;
  }

  .sm\\:min-h-0{
    min-height: 0px;
  }

  .sm\\:min-h-\\[36px\\]{
    min-height: 36px;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-11{
    width: 2.75rem;
  }

  .sm\\:w-16{
    width: 4rem;
  }

  .sm\\:w-44{
    width: 11rem;
  }

  .sm\\:w-48{
    width: 12rem;
  }

  .sm\\:w-5{
    width: 1.25rem;
  }

  .sm\\:w-56{
    width: 14rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-\\[210px\\]{
    width: 210px;
  }

  .sm\\:w-\\[480px\\]{
    width: 480px;
  }

  .sm\\:w-\\[540px\\]{
    width: 540px;
  }

  .sm\\:w-\\[640px\\]{
    width: 640px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:min-w-\\[100px\\]{
    min-width: 100px;
  }

  .sm\\:max-w-\\[240px\\]{
    max-width: 240px;
  }

  .sm\\:max-w-\\[320px\\]{
    max-width: 320px;
  }

  .sm\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .sm\\:max-w-\\[640px\\]{
    max-width: 640px;
  }

  .sm\\:max-w-\\[680px\\]{
    max-width: 680px;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-none{
    max-width: none;
  }

  .sm\\:max-w-xl{
    max-width: 36rem;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-center{
    justify-content: center;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-2{
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-3\\.5{
    gap: 0.875rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-6{
    gap: 1.5rem;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:break-normal{
    overflow-wrap: normal;
    word-break: normal;
  }

  .sm\\:rounded-card{
    border-radius: 16px;
  }

  .sm\\:rounded-none{
    border-radius: 0px;
  }

  .sm\\:rounded-t-none{
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  .sm\\:border{
    border-width: 1px;
  }

  .sm\\:border-l{
    border-left-width: 1px;
  }

  .sm\\:border-t-0{
    border-top-width: 0px;
  }

  .sm\\:border-zinc-200{
    --tw-border-opacity: 1;
    border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
  }

  .sm\\:p-12{
    padding: 3rem;
  }

  .sm\\:p-2\\.5{
    padding: 0.625rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-3\\.5{
    padding: 0.875rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-0{
    padding-bottom: 0px;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .sm\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-8{
    padding-bottom: 2rem;
  }

  .sm\\:pr-8{
    padding-right: 2rem;
  }

  .sm\\:pt-0{
    padding-top: 0px;
  }

  .sm\\:pt-4{
    padding-top: 1rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-8xl{
    font-size: 6rem;
    line-height: 1;
  }

  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .sm\\:text-\\[13px\\]{
    font-size: 13px;
  }

  .sm\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:duration-150{
    transition-duration: 150ms;
  }

  .sm\\:fade-in-0{
    --tw-enter-opacity: 0;
  }

  .sm\\:zoom-in-95{
    --tw-enter-scale: .95;
  }

  .sm\\:slide-in-from-bottom-0{
    --tw-enter-translate-y: 0px;
  }

  .sm\\:duration-150{
    animation-duration: 150ms;
  }

  .dark\\:sm\\:border-zinc-800:is(.dark *){
    --tw-border-opacity: 1;
    border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
  }
}

@media (min-width: 768px){

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:table-cell{
    display: table-cell;
  }

  .md\\:w-\\[580px\\]{
    width: 580px;
  }

  .md\\:max-w-\\[680px\\]{
    max-width: 680px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px){

  .lg\\:top-4{
    top: 1rem;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .lg\\:ml-4{
    margin-left: 1rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:inline{
    display: inline;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:inline-flex{
    display: inline-flex;
  }

  .lg\\:table-cell{
    display: table-cell;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-\\[calc\\(100dvh-2rem\\)\\]{
    height: calc(100dvh - 2rem);
  }

  .lg\\:w-64{
    width: 16rem;
  }

  .lg\\:w-\\[760px\\]{
    width: 760px;
  }

  .lg\\:min-w-\\[125px\\]{
    min-width: 125px;
  }

  .lg\\:max-w-\\[340px\\]{
    max-width: 340px;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:rounded-3xl{
    border-radius: 1.5rem;
  }

  .lg\\:border-t-0{
    border-top-width: 0px;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:px-3\\.5{
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .lg\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .lg\\:pt-0{
    padding-top: 0px;
  }
}

@media (min-width: 1280px){

  .xl\\:inline{
    display: inline;
  }

  .xl\\:table-cell{
    display: table-cell;
  }
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,uGAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,6EAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,kEAAc;IAAd,uFAAc;IAAd,kEAAc;IAAd,oBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,0BAAc;;IAAd,iBAAc;IAAd,+BAAc;IAAd,oBAAc;IAAd,kCAAc;;IAAd,4CAAc;IAAd,uBAAc;IAAd,8BAAc;IAAd,2BAAc;IAAd,oCAAc;IAAd,uBAAc;IAAd,kCAAc;IAAd,wBAAc;IAAd,iCAAc;;IAAd,4BAAc;IAAd,kCAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,iBAAc;;IAAd,qBAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,8BAAc;IAAd,iCAAc;;IAAd,sBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,qBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,mBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,oBAAc;IAAd,2BAAc;IAAd,0BAAc;IAAd,qBAAc;IAAd,0BAAc;;IAAd,oBAAc;IAAd,4BAAc;IAAd,qBAAc;IAAd,qBAAc;;IAAd,uBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,oBAAc;;IAAd,8EAAc;IAAd,mFAAc;IAAd,mDAAc;EAAA;;EAAd;IAAA,kEAAc;IAAd,iEAAc;IAAd,kEAAc;IAAd,iBAAc;IAAd,qBAAc;IAAd,sBAAc;;IAAd,oBAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,8BAAc;;IAAd,wCAAc;IAAd,mBAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,gCAAc;IAAd,uBAAc;IAAd,gCAAc;IAAd,wBAAc;IAAd,6BAAc;;IAAd,4BAAc;IAAd,kCAAc;IAAd,wBAAc;IAAd,uBAAc;IAAd,gBAAc;;IAAd,iBAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,8BAAc;IAAd,iCAAc;;IAAd,sBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,qBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,mBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,gBAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,0BAAc;;IAAd,gBAAc;IAAd,2BAAc;IAAd,qBAAc;IAAd,qBAAc;;IAAd,mBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,oBAAc;;IAAd,qEAAc;IAAd,2EAAc;IAAd,kFAAc;IAAd,oDAAc;EAAA;;EAAd;EAAA,sBAAc;EAAd;AAAc;;EAAd;IAAA,8BAAc;IAAd,uBAAc;EAAA;;EAAd;EAAA,kBAAc;EAAd,kEAAc;EAAd,oBAAc;EAAd,yDAAc;IAAd,qCAAc;IAAd,mCAAc;IAAd,kCAAc;IAAd;AAAc;;EAAd,kDAAc;EAAd;;;;;IAAA,0BAAc;IAAd,wCAAc;EAAA;;EAAd,wDAAc;EAAd;IAAA,UAAc;IAAd,WAAc;EAAA;;EAAd;IAAA,uBAAc;EAAA;;EAAd;IAAA,+CAAc;IAAd,qBAAc;EAAA;;EAAd;IAAA,+CAAc;EAAA;;EAAd;IAAA,qBAAc;IAAd,gEAAc;EAAA;;EAAd,yCAAc;EAAd;;;IAAA,kCAAc;EAAA;;EAAd,4DAAc;EAAd;;;;IAAA,kEAAc;IAAd,0DAAc;IAAd,8CAAc;IAAd,yDAAc;IAAd,iDAAc;EAAA;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AA+MnB;EACE;;;IAGE,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AA3NA;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,mBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,0CA2NC;EA3ND,uDA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,8BA2NC;EA3ND;AA2NC;;AA3ND;EAAA,2GA2NC;EA3ND,yGA2NC;EA3ND;AA2NC;;AA3ND;EAAA,2GA2NC;EA3ND,yGA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,8BA2NC;EA3ND;AA2NC;;AA3ND;EAAA,2GA2NC;EA3ND,yGA2NC;EA3ND;AA2NC;;AA3ND;EAAA,2GA2NC;EA3ND,yGA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,iBA2NC;EA3ND,iBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,8BA2NC;EA3ND;AA2NC;;AA3ND;EAAA,2GA2NC;EA3ND,yGA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,yBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,0BA2NC;EA3ND;AA2NC;;AA3ND;EAAA,yBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,0BA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,qBA2NC;EA3ND,yBA2NC;EA3ND,2BA2NC;EA3ND,yBA2NC;EA3ND,0BA2NC;EA3ND,+BA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND,yBA2NC;EA3ND,0BA2NC;EA3ND,wBA2NC;EA3ND,yBA2NC;EA3ND,8BA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;;EAAA;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;AAAA;;AA3ND;;EAAA;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;AAAA;;AA3ND;;EAAA;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;AAAA;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,gDA2NC;EA3ND,6DA2NC;EA3ND;AA2NC;;AA3ND;EAAA,mCA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,sBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,kBA2NC;EA3ND;AA2NC;;AA3ND;EAAA,oBA2NC;EA3ND;AA2NC;;AA3ND;;EAAA;IAAA;EA2NC;AAAA;;AA3ND;;EAAA;IAAA,UA2NC;IA3ND;EA2NC;;EA3ND;IAAA,QA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,mBA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,uBA2NC;IA3ND,sDA2NC;IA3ND;EA2NC;;EA3ND;IAAA,uBA2NC;IA3ND,+DA2NC;IA3ND;EA2NC;;EA3ND;IAAA,uBA2NC;IA3ND,8DA2NC;IA3ND;EA2NC;;EA3ND;IAAA,qBA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,2BA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,sBA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,kBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,oBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,qBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,kBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,qBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,oBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,kBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,gBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,iBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,iBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,qBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,iBA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,iBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,kBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,eA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,eA2NC;IA3ND;EA2NC;;EA3ND;IAAA,mBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,mBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,kBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,kBA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,sBA2NC;IA3ND;EA2NC;AAAA;;AA3ND;;EAAA;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;AAAA;;AA3ND;;EAAA;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,gBA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;;EA3ND;IAAA,sBA2NC;IA3ND;EA2NC;;EA3ND;IAAA,qBA2NC;IA3ND;EA2NC;;EA3ND;IAAA;EA2NC;AAAA;;AA3ND;;EAAA;IAAA;EA2NC;;EA3ND;IAAA;EA2NC;AAAA;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA,gBA2NC;EA3ND,oBA2NC;EA3ND,4BA2NC;EA3ND;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC;;AA3ND;EAAA;AA2NC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  :root {\n    /* ------------------------------------------------------------- */\n    /* Light Mode: Folk & Linear-inspired clean neutral zinc palette with #F7F7F7 surface */\n    /* ------------------------------------------------------------- */\n    --canvas: 0 0% 96.9%; /* #F7F7F7 */\n    --background: 0 0% 96.9%; /* #F7F7F7 */\n    --foreground: 240 10% 3.9%;\n\n    --card: 0 0% 100%;\n    --card-foreground: 240 10% 3.9%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 240 10% 3.9%;\n\n    /* Solid charcoal / deep black primary CTA */\n    --primary: 240 5.9% 10%;\n    --primary-foreground: 0 0% 98%;\n    --secondary: 240 4.8% 95.9%;\n    --secondary-foreground: 240 5.9% 10%;\n    --muted: 240 4.8% 95.9%;\n    --muted-foreground: 240 3.8% 46.1%;\n    --accent: 240 4.8% 95.9%;\n    --accent-foreground: 240 5.9% 10%;\n\n    --destructive: 0 84.2% 60.2%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 240 5.9% 90%;\n    --input: 240 5.9% 90%;\n    --ring: 240 5.9% 10%;\n    --radius: 0.75rem;\n\n    --brand: 240 5.9% 10%;\n    --brand-foreground: 0 0% 98%;\n    --brand-soft: 240 4.8% 95.9%;\n    --color-brand-primary: #18181b;\n    --color-brand-foreground: #ffffff;\n\n    --success: 142 72% 29%;\n    --success-soft: 142 50% 94%;\n    --success-solid: 142 70% 40%;\n    --warning: 38 92% 38%;\n    --warning-soft: 40 90% 94%;\n    --warning-solid: 38 92% 50%;\n    --danger: 0 72% 45%;\n    --danger-soft: 0 70% 95%;\n    --danger-solid: 0 72% 50%;\n    --info: 240 5.9% 10%;\n    --info-soft: 240 4.8% 95.9%;\n    --info-solid: 240 5.9% 10%;\n    --violet: 267 50% 45%;\n    --violet-soft: 262 70% 94%;\n\n    --tile: 240 5.9% 10%;\n    --tile-foreground: 0 0% 100%;\n    --ai-glow: 54 90% 70%;\n    --ai-tile: 52 90% 88%;\n\n    --chart-1: 240 5.9% 10%;\n    --chart-2: 142 70% 45%;\n    --chart-3: 38 92% 50%;\n    --chart-4: 267 50% 55%;\n    --chart-5: 0 72% 50%;\n\n    --shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.04), 0 1px 2px -1px rgb(0 0 0 / 0.04);\n    --shadow-pop: 0 10px 25px -5px rgb(0 0 0 / 0.06), 0 8px 10px -6px rgb(0 0 0 / 0.04);\n    --shadow-shell: 0 20px 40px -15px rgb(0 0 0 / 0.08);\n  }\n\n  .dark {\n    /* ------------------------------------------------------------- */\n    /* Dark Mode: True OLED pitch black + crisp dark zinc depth     */\n    /* ------------------------------------------------------------- */\n    --canvas: 0 0% 0%;\n    --background: 0 0% 0%;\n    --foreground: 0 0% 98%;\n\n    --card: 240 10% 3.9%;\n    --card-foreground: 0 0% 98%;\n    --popover: 240 10% 3.9%;\n    --popover-foreground: 0 0% 98%;\n\n    /* Crisp white CTA button in dark mode */\n    --primary: 0 0% 98%;\n    --primary-foreground: 240 5.9% 10%;\n    --secondary: 240 3.7% 15.9%;\n    --secondary-foreground: 0 0% 98%;\n    --muted: 240 3.7% 15.9%;\n    --muted-foreground: 240 5% 64.9%;\n    --accent: 240 3.7% 15.9%;\n    --accent-foreground: 0 0% 98%;\n\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 240 3.7% 15.9%;\n    --input: 240 3.7% 15.9%;\n    --ring: 0 0% 98%;\n\n    --brand: 0 0% 98%;\n    --brand-foreground: 0 0% 100%;\n    --brand-soft: 240 3.7% 15.9%;\n    --color-brand-primary: #f4f4f5;\n    --color-brand-foreground: #09090b;\n\n    --success: 142 70% 50%;\n    --success-soft: 142 50% 12%;\n    --success-solid: 142 70% 45%;\n    --warning: 38 90% 60%;\n    --warning-soft: 38 45% 14%;\n    --warning-solid: 38 85% 52%;\n    --danger: 0 84% 65%;\n    --danger-soft: 0 45% 15%;\n    --danger-solid: 0 84% 58%;\n    --info: 0 0% 98%;\n    --info-soft: 240 3.7% 15.9%;\n    --info-solid: 0 0% 98%;\n    --violet: 265 80% 70%;\n    --violet-soft: 265 40% 16%;\n\n    --tile: 0 0% 12%;\n    --tile-foreground: 0 0% 96%;\n    --ai-glow: 54 80% 45%;\n    --ai-tile: 50 35% 15%;\n\n    --chart-1: 0 0% 98%;\n    --chart-2: 142 70% 50%;\n    --chart-3: 38 90% 60%;\n    --chart-4: 267 70% 72%;\n    --chart-5: 0 84% 65%;\n\n    /* OLED deep black depth: crisp 1px borders + high-contrast shadows */\n    --shadow-card: 0 0 0 1px hsl(0 0% 100% / .08), 0 2px 10px hsl(0 0% 0% / .8);\n    --shadow-pop: 0 0 0 1px hsl(0 0% 100% / .10), 0 16px 40px -12px hsl(0 0% 0% / .95);\n    --shadow-shell: 0 24px 60px -24px hsl(0 0% 0% / .98);\n  }\n\n  * {\n    @apply border-border;\n  }\n\n  html {\n    -webkit-text-size-adjust: 100%;\n    scroll-behavior: smooth;\n  }\n\n  body {\n    @apply bg-background text-foreground antialiased;\n    font-feature-settings: \"cv11\", \"ss01\";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n  }\n\n  /* Universal high-performance interactive states */\n  button,\n  a,\n  input,\n  select,\n  textarea {\n    touch-action: manipulation;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  /* Sleek modern scrollbars across all desktop browsers */\n  ::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: hsl(var(--muted-foreground) / 0.25);\n    border-radius: 9999px;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: hsl(var(--muted-foreground) / 0.45);\n  }\n\n  * {\n    scrollbar-width: thin;\n    scrollbar-color: hsl(var(--muted-foreground) / 0.25) transparent;\n  }\n\n  /* Clean tabular and numeric alignments */\n  .tabular,\n  table,\n  [data-numeric] {\n    font-variant-numeric: tabular-nums;\n  }\n\n  /* Strict anti-blue/anti-yellow browser autofill overrides */\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 1000px hsl(var(--card)) inset !important;\n    -webkit-text-fill-color: hsl(var(--foreground)) !important;\n    caret-color: hsl(var(--foreground)) !important;\n    transition: background-color 5000s ease-in-out 0s;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
